import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { catTree, dateFormat } from '../../../module/ConstantFunctions';
import Spinner from '../../../Constants/Spinner';
import HashIcon from '../../../Assets/Icons/HashIcon';
import CalenderIcon from '../../../Assets/Icons/CalenderIcon';
import DraftIcon from '../../../Assets/Icons/DraftIcon';
import EditIcon from '../../../Assets/Icons/EditIcon';
import DeleteIcon from '../../../Assets/Icons/DeleteIcon';

function Post({ showModal, data, index, statusFunction, deleteFunction }) {
  const [publishLoader, setPublishLoader] = useState(false);
  const [deleteLoader, setDeleteLoader] = useState(false);
  return (
    <div
      key={index}
      className="Post bg-[#eef2f0] p-6 flex flex-col justify-between rounded-s-lg md:w-[calc(50%-15px)] w-full">
      <div className=" w-full">
        <div className="postDetails flex w-full justify-between sm:flex-row flex-col">
          <div className="flex items-center justify-between sm:w-[48%] w-full sm:mt-0  bg-white rounded-[12px] py-[8px] pr-[8px] pl-[16px]">
            <div className="flex items-center">
              <div>
                <HashIcon />
              </div>
              <div className="ml-[16px]">
                <p className="text-xs text-[#7b867c]">Post Number</p>
                <p dir="ltr" className="urduText text-[25px] leading-[19px]" style={{ textAlign: 'left' }}>
                  {data.post_number}
                </p>
              </div>
            </div>
          </div>
          <div className="flex items-center sm:w-[48%] w-full sm:mt-0 mt-4 bg-white rounded-[12px] py-[11px] pr-[8px] pl-[16px]">
            <div>
              <CalenderIcon />
            </div>
            <div className="ml-[16px]">
              <p className="text-xs text-[#7b867c]">Post Date</p>
              <p className="font-semibold">{dateFormat(data.date_post)}</p>
            </div>
          </div>
        </div>
        <div className="postText">
          <p className="text-sm text-[#7b867c] pt-[24px] font-medium">Post Text</p>
          <p dir="ltr" className="urduText font-bold line-clamp-2 text-text-ellipsis leading-[36px]">
            {data.preview}
          </p>
        </div>
        <div className="viewPost flex items-center justify-between pt-4 sm:flex-row flex-col-reverse">
          <button
            className="bg-white w-[142px]  text-[#2a9134] border-[1px] leading-[8px] outline-none  sm:mt-0 mt-2 border-[#2a9134]  py-3 rounded-full font-semibold transition ease-in-out delay-150 hover:-translate-y-0.5 hover:scale-105 whitespace-nowrap"
            onClick={() => showModal(data)}>
            View Post
          </button>
          <p
            dir="ltr"
            className="urduText text-[#2a9134] text-xl font-bold text-text-ellipsis line-clamp-1 leading-[inherit] w-[calc(100%-142px)]">
            {/* عنوان ١ › عنوان ٢ › عنوان ٣ */}
            {data.categories.map(c => c.category_name).join(' > ')}
          </p>
        </div>
      </div>
      <div className="tools flex items-center justify-between flex-wrap">
        <button
          disabled={publishLoader}
          className="relative text-white bg-black flex items-center justify-center h-[48px] sm:w-[48%] sm:mt-0 mt-6 w-full px-4 rounded-xl transition ease-in-out delay-150 hover:-translate-y-0.5 hover:scale-105"
          onClick={() => statusFunction(data, 'draft', setPublishLoader)}>
          {publishLoader ? <Spinner /> : null}

          <span
            className={
              publishLoader ? `opacity-0 flex items-center justify-center` : 'flex items-center justify-center'
            }>
            <DraftIcon className="mr-[6px]" />
            Move to Drafts
          </span>
        </button>

        <div className="flex items-center justify-between sm:w-[48%] w-full py-6">
          <Link className="w-[48%]" to={`/edit-post?id=${data._id}`}>
            <button className="w-full text-white bg-white  flex items-center justify-center h-[48px] px-4 rounded-xl transition ease-in-out delay-150 hover:-translate-y-0.5 hover:scale-105">
              <EditIcon width={26} height={24} fill="#000" />
            </button>
          </Link>
          <button
            disabled={deleteLoader}
            className="relative w-[48%] text-white bg-[#ca3030]  flex items-center justify-center h-[48px] px-4 rounded-xl transition ease-in-out delay-150 hover:-translate-y-0.5 hover:scale-105"
            onClick={() => deleteFunction(data._id, setDeleteLoader)}>
            {deleteLoader ? <Spinner /> : null}

            <span
              className={
                deleteLoader ? `opacity-0 flex items-center justify-center` : 'flex items-center justify-center'
              }>
              <DeleteIcon pathProp={{ fill: '#fff' }} />
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default Post;
